export default __webpack_public_path__ + "static/media/Micah Georgewill.e0b5c688.jpg";